import { Articulation } from 'types/articulation';
import CreditItemCard from 'components/common/CreditItemCard';
import { CreditType } from 'types/credit';
import SourceCredentialSection from 'components/credits/credit-items/SourceCredentialSection';
import { TargetArticulationsSection } from 'components/credits/credit-items/TargetArticulationsSection';

import { getArticulationsAltText } from 'utils/aria';
import useFormSchema from 'hooks/use-form-schema';
import { useMemo } from 'react';

type Props = {
  articulations: Articulation[];
};

export default function ArticulationCreditItem(props: Props): JSX.Element {
  const { articulations } = props;
  const formSchema = useFormSchema();

  const ariaText = useMemo(() => {
    if (!formSchema) {
      return;
    }
    return getArticulationsAltText(articulations, formSchema, false);
  }, [articulations, formSchema]);

  if (!formSchema) {
    return <></>;
  }

  return (
    <div>
      <div className='sr-only'>{ariaText}</div>
      <CreditItemCard
        sourceComponent={
          <SourceCredentialSection
            requiredCredentials={articulations[0].requiredCredentials}
            creditItemID={articulations[0].ID}
            creditType={CreditType.ARTICULATION}
          />
        }
        targetComponent={<TargetArticulationsSection articulations={articulations} />}
      />
    </div>
  );
}
